<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RequAddMain from '@/views/DevelopManagement/RequManage/TabChild/RequAddMain';
export default {
  name: 'RequAdd',
  components: {
    childTab1: RequAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  }
};
</script>

<style scoped></style>
